/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
/* tslint:disable: no-duplicate-imports */
import { observable } from 'mobx';


/**
 * ListPageState class
 */
export class ListPageStateBuyBox {
    @observable public variantId:  string | undefined = '';
    @observable public itemId:  string | undefined = '';
    @observable public name:  string | undefined = '';
    @observable public categoryName:  string | undefined = '';
    @observable public productBrandName:  string | undefined = '';
    @observable public price:  string | undefined = '';
    @observable public productUrl:  string | undefined = '';
    @observable public productImageUrl:  string | undefined = '';
    @observable public productSize:  string | undefined = '';
}

/**
 * ListPageStateInput - action input
 */
export class ListPageStateBuyBoxInput implements IActionInput {
    public getCacheKey = () => `ListPageStateBuyBox`;
    public getCacheObjectType = () => 'ListPageStateBuyBox';
    public dataCacheType = (): CacheType => 'application';
}

export async function listPageStateAction(
    input: ListPageStateBuyBoxInput,
    ctx: IActionContext
): Promise<ListPageStateBuyBox> {
    return new ListPageStateBuyBox();
}

/**
 * create new input for create action
 */
export const createListPageInput = (
    inputData: ICreateActionContext<IGeneric<IAny>>
): IActionInput => {
    return new ListPageStateBuyBoxInput();
};

/**
 * ListPageState - create action
 */
export default createObservableDataAction<ListPageStateBuyBox>({
    action: <IAction<ListPageStateBuyBox>>listPageStateAction,
    input: createListPageInput
});
